import React, { useState } from "react";
import "../css/rejection.reason.css";
import { Input } from "antd";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import { TOAST_CLASSES, UNPUBLISHED_TXT } from "../../../utils/constants";
import { useAgent } from "../../../contexts/AgentsContext";

const ReasonForRejctionAgent = ({
  setEnableReasonBox,
  agentId,
  clearAgentDrawerData,
}) => {
  const { publishAgent, isApprovingRejecting, showToastMessage } = useAgent();

  const [rejectionReason, setRejectionReason] = useState("");

  // Handle unpublished
  const handleUnpublish = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!agentId) {
      showToastMessage("Agent ID is not available.", TOAST_CLASSES?.ERROR);
      return;
    }
    await publishAgent(agentId, UNPUBLISHED_TXT, rejectionReason);

    await clearAgentDrawerData();

    setEnableReasonBox(false);
  };

  return (
    <>
      <div className="rejection-info-container" style={{ marginTop: "32px" }}>
        <div className="row">
          <div className="col-md-12">
            <label className="rejection-info-title mb-3">
              Reason for Rejection
            </label>
            <span className="marketplace-req-asterik">*</span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="rejection-details">
              <div className="rejection-detail-row mb-3">
                <div className="col-md-12">
                  <Input
                    type="text"
                    placeholder="Type Reason for Rejection"
                    className="custom-input-size"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e?.target?.value)}
                    disabled={isApprovingRejecting}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <CustomButton
            label="Cancel"
            onClickFn={() => setEnableReasonBox(false)}
            clsNames={"mas-btn-med mas-secondary-btn"}
            disabled={isApprovingRejecting}
          />
          <CustomButton
            label="Submit"
            onClickFn={(e) => handleUnpublish(e, agentId)}
            clsNames={"mas-btn-med mas-primary-btn"}
            disabled={
              isApprovingRejecting || rejectionReason === "" || !rejectionReason
            }
          />
        </div>
      </div>
    </>
  );
};

export default ReasonForRejctionAgent;
